export default __webpack_public_path__ + "static/media/naviconC.ba276e97.svg";